module.exports = __webpack_public_path__ + "static/img/VI规范设计-VI标准.ba80b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10003/VI规范设计-VI标准.png
// module id = 3PgR
// module chunks = 1